import React, { useRef } from 'react'
import Slider from "react-slick";
import { getImages } from '../../Common/const';

const reviewsList = [
    {
        name: "Darren Magot",
        date: '2 months ago',
        content:
            "I had a great experience with these guys. They have such a wide variety of unique vehicles. Definitely will be going back whenever I’m in the area to see what’s new.",
    },
    {
        name: "R PHOTOSTUDIOS",
        date: 'a month ago',
        content:
            "Jackson was very welcoming when we visited the showroom. Knowledgeable and patient with my son who was so excited to see their cars.",
    },
    {
        name: "cat lover",
        date: '2 months ago',
        content:
            "Tim had great communication. I didn’t see the car in person, so I had to trust…and I ended up very pleased. As described. Thank you",
    },

    {
        name: "Alek Arciniega",
        date: 'a month ago',
        content:
            "Awesome place to go look at exotic cars. The guys working there were very helpful and informative. Definitely recommend coming here and checking this place out.",
    },
    {
        name: "Muntasir Hoque",
        date: '6 days ago',
        content:
            "Excellent experience with purchase and delivery of a vehicle from EEC! Jaxon was my point of contact, and he was incredibly knowledgeable and friendly the entire process. They delivered the vehicle to a location of my choosing, and made the entire experience a pleasure. I cannot recommend Jaxon and EEC enough. This is the best place in California to purchase exotic automobiles!",
    },

    {
        name: "Ishnmuich Perez",
        date: 'a month ago',
        content:
            "Very friendly professional staff. Not only were they very friendly and courteous with my son, but they gave us good information on their weekly car shows held at the parking lot.",
    },
    {
        name: "Summer Shaffer",
        date: '2 months ago',
        content:
            "Whole staff was super friendly and very knowledgeable. Was the easiest car purchase I’ve ever made. Will be my first call when I’m ready for something new!",
    },
];

const HomeReviews = () => {
    const sliderRef = useRef(null);
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 2,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: true,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };
    return (
        <>
            <section className='unmatched-service-wrap'>
                <div className='container'>
                    <div className='d-md-flex align-items-center justify-content-between usw-flex mb-4 px-4'>
                        <div>
                            <h3 className='xxl-title font-3em fw-300 text-uppercase reveal wow fadeInUp'>Unmatched Service</h3>
                        </div>
                        <div className='d-flex align-items-center g-review-flex justify-content-between'>
                            <div className='me-4'>
                                <div className='xxl-title font-3em fw-700 mb-1 text-uppercase reveal wow fadeInUp'>5.0</div>
                                <div className="d-flex align-items-center">
                                    {[...Array(5)].map((_, i) => (
                                        <img key={i} className="me-1 mrs-icon" src={getImages("star.svg")} alt="star" />
                                    ))}
                                </div>
                            </div>
                            <div className='review-google-icon'>
                                <img src={getImages('icon-testimonial-user1.png')}/>
                            </div>
                        </div>
                    </div>
                    <div className='reveal wow fadeIn'>
                        <Slider ref={sliderRef} {...settings} className='review-slider'>
                            {reviewsList.map((review, index) => (
                                <div className="review-item" key={index}>
                                    <div className="review-box">
                                        <div className="d-flex justify-content-between mt-1">
                                            <div>
                                                <div className="reviewer-name">{review.name}</div>
                                                <div className="d-flex align-items-center">
                                                    {[...Array(5)].map((_, i) => (
                                                        <img key={i} className="me-1 rs-icon" src={getImages("star.svg")} alt="star" />
                                                    ))}
                                                </div>
                                            </div>
                                            <div>
                                                <div className="quote-icon mb-2">
                                                    <img src={getImages("quote-shape.png")} alt="quote" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="review-mnh">
                                            <p className="clamp-4">
                                                {review.content}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            ))}

                        </Slider>
                    </div>
                </div>
            </section>
        </>
    )
}

export default HomeReviews
